import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import DepositAgreementSection from "./sections/DepositAgreementSection";

const DepositAgreement = () => {
  const match = useRouteMatch();
  const { t } = useTranslation(["shared\\moduleNames"]);

  return (
    <Switch>
      <Route path={match.path}>
        <Header title={t("depositAgreement.title")} includeBreadcrumbs />
        <ModuleContent>
          <DepositAgreementSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
};

export default DepositAgreement;
